import { mockMaintenanceTask } from "mocks/mock-maintenance-tasks";
import { type MaintenanceTask } from "types/maintenance-task";
import { apiClient } from "utils/api-client/index";
import { createModel } from "utils/models";

export type MaintenanceData = {
  data: MaintenanceTask[];
};

export type MaintenanceFormValues = {
  summary: string;
  description: string | null;
  images: File[];
};

export type CreateMaintenanceTaskPayload = {
  summary: string;
  description: string | null;
  property_tenancy_id: string | null;
  images: File[];
};

export const tenancyMaintenanceModel = createModel("tenancyMaintenance", {
  queries: {
    list: (propertyTenancyId?: string) => ({
      queryKey: ["read", propertyTenancyId],
      queryFn: () => {
        return apiClient.get<MaintenanceData>(
          `/tenant-portal/maintenance?property_tenancy_id=${propertyTenancyId}`,
        );
      },
      enabled: !!propertyTenancyId,
      keepPreviousData: true,
    }),
  },
  mutations: {
    create: () => ({
      mutationFn: (payload: CreateMaintenanceTaskPayload) => {
        const formData = new FormData();

        formData.append("summary", payload.summary);
        formData.append("description", payload.description ?? "");
        formData.append(
          "property_tenancy_id",
          payload.property_tenancy_id ?? "",
        );

        payload.images.forEach((file, index) => {
          formData.append(`images[${index}]`, file);
        });

        return apiClient.upload(
          "/tenant-portal/maintenance",
          payload.images,
          payload,
        );
      },
    }),
  },
});

export const mockTenancyMaintenanceResponse = () => {
  return {
    data: Array.from({ length: 8 }).map(() => mockMaintenanceTask()),
  };
};
